"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearButton = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Close_1 = tslib_1.__importDefault(require("wix-ui-icons-common/system/Close"));
var button_next_1 = require("wix-ui-core/button-next");
var ClearButton_st_css_1 = require("./ClearButton.st.css");
exports.ClearButton = function (_a) {
    var onClick = _a.onClick, props = tslib_1.__rest(_a, ["onClick"]);
    return (React.createElement(button_next_1.ButtonNext, tslib_1.__assign({}, props, { className: ClearButton_st_css_1.st(ClearButton_st_css_1.classes.root, props.className), onClick: onClick, "data-hook": "clear-button" }),
        React.createElement(Close_1.default, { width: '8px', height: '8px' })));
};
//# sourceMappingURL=index.js.map